<div class="filter-container flex flex_column">
  <div class="filter-header flex_sb">
    <div class="flex align_center gap-4">
      <div class="img-16 flex-center" (click)="cancelClicked()">
        <img class="wd-100-hg-100" [src]="images.MPOS_CROSS" alt="close-icon" />
      </div>
      <div class="fs-20 fw-600 clr-333 lh-130">
        {{ 'MPOS_FILTERS.FILTER_BY' | fallbackTranslate }}
      </div>
    </div>
    <div
      class="clear-filter fs-14 fw-600 lh-140 clr-333"
      [ngClass]="{
        'disable-action': !selectedFilter?.selectedOptionsCount
      }"
      (click)="resetSelectedOptions()"
    >
      {{ 'MPOS_FILTERS.CLEAR_ALL' | fallbackTranslate }}
    </div>
  </div>
  <div class="filter-body flex align_center flex-1">
    <div class="category-list-container flex-2">
      <!-- Loop through filter names and display them -->
      <div
        *ngFor="let filter of cloneModalData"
        class="filter-name fs-14 flex_sb lh-140"
        [ngClass]="
          selectedFilter.filterId === filter.filterId
            ? 'selected-filter fw-600 clr-333'
            : 'fw-400 clr-999'
        "
        (click)="filterClicked(filter)"
      >
        <span> {{ filter?.filterName }}</span>
        <span
          *ngIf="filter?.selectedOptionsCount > 0"
          class="selected-count fs-12 fw-600 lh-130 color-white img-20 ta_center p-t-3"
          >{{ filter?.selectedOptionsCount }}
        </span>
      </div>
    </div>
    <div class="options-container flex-3">
      <!-- Display options for the selected filter -->
      <div *ngIf="selectedFilter" class="filter-options">
        <div
          *ngFor="let option of selectedFilter.options"
          class="option-wrapper"
        >
          <div
            class="option wd-100 fw-400 fs-14 clr-333 lh-140"
            nz-checkbox
            [(ngModel)]="option.isSelected"
            (ngModelChange)="updateChecked(option)"
          >
            {{ option?.optionName }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="filter-footer">
    <button class="wd-100 apply-btn fw-600 lh-130" (click)="applyFilters()">
      {{ 'MPOS_FILTERS.APPLY' | fallbackTranslate }}
    </button>
  </div>
</div>
